import React from 'react';

import { AppPostInit as AppPostInitCore } from '@core/js/components/system/App/components/AppPostInit/AppPostInit';

import { useAfterInitHooks } from '@interlayer/js/components/system/App/sun/hooks';

export const AppPostInit = React.memo(() => {
    useAfterInitHooks();

    return (
        <>
            <AppPostInitCore />
        </>
    );
});
